import { motion } from "framer-motion";

const ease = [0.16, 1, 0.3, 1];

export default function Preloader({ onDone }) {
  const letters = "ΤΑΞΙΔΙΩΤΕΣ".split("");

  return (
    <motion.div
      data-testid="preloader"
      className="fixed inset-0 z-[100] flex items-center justify-center bg-[var(--bg)]"
      initial={{ opacity: 1 }}
      animate={{ opacity: 1 }}
      exit={{ y: "-100%" }}
      transition={{ duration: 0.9, ease, delay: 1.5 }}
      onAnimationComplete={onDone}
    >
      <div className="overflow-hidden px-6">
        <motion.h1
          className="font-serif text-4xl sm:text-6xl lg:text-7xl tracking-[0.15em] text-[var(--fg)] flex"
          initial="hidden"
          animate="show"
        >
          {letters.map((l, i) => (
            <motion.span
              key={i}
              variants={{
                hidden: { y: "110%", opacity: 0 },
                show: { y: "0%", opacity: 1 },
              }}
              transition={{ duration: 0.7, ease, delay: 0.2 + i * 0.06 }}
              className="inline-block"
            >
              {l}
            </motion.span>
          ))}
        </motion.h1>
      </div>
      <motion.span
        className="absolute bottom-10 left-1/2 -translate-x-1/2 font-mono text-[10px] tracking-[0.4em] text-[var(--muted)]"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.5, duration: 0.8 }}
      >
        GOSPEL · THESSALONIKI
      </motion.span>
    </motion.div>
  );
}
